import {
  getRawContentFromTextComponent,
} from '@msd-npm-gmc-dev/gmc-dc-assembler-draftjs2lexical';
import { cloneDeep } from 'lodash';
import * as Models from 'models';
import { isImmutable } from 'utils/immutable';
import { convertRawContent2LexicalState, ConverterType } from './RawContentConverter';

const cache = new Map();

/**
 * fonts is optional but will prevent updating the editor state on mount
 */
export function confirmLexicalStateInTextComponent(
  textComponent: Models.TextComponent,
  relationStyles: Models.TextRelationStyles | null,
  fonts?: Models.BrandFontsList,
): Models.TextComponent;
export function confirmLexicalStateInTextComponent(
  textComponent: Models.TextComponentMap,
  relationStyles: Models.TextRelationStyles | null,
  fonts?: Models.BrandFontsList,
): Models.TextComponentMap;
export function confirmLexicalStateInTextComponent(
  textComponent: Models.TextComponentMap | Models.TextComponent,
  relationStyles: Models.TextRelationStyles | null,
  fonts?: Models.BrandFontsList,
): Models.TextComponentMap | Models.TextComponent {
  const isImmutableMap = isImmutable(textComponent);
  if (isImmutableMap ? textComponent.get('lexicalState') : textComponent.lexicalState) {
    return textComponent;
  }

  const componentKey = JSON.stringify(isImmutableMap ? textComponent.toJSON() : textComponent);
  const relationsKey = JSON.stringify(relationStyles);
  const cacheKey = `${String(isImmutableMap)}_${componentKey}_${relationsKey}`;
  if (cache.has(cacheKey)) {
    return cache.get(cacheKey);
  }

  const rawContent = getRawContentFromTextComponent(textComponent, relationStyles);
  const lexicalState = rawContent
    ? JSON.stringify(convertRawContent2LexicalState({ rawContent, fonts, type: ConverterType.TEXT }))
    : null;

  if (isImmutable(textComponent)) {
    const updatedComponent = textComponent.set('lexicalState', lexicalState);
    cache.set(cacheKey, updatedComponent);

    return updatedComponent;
  }

  const updatedComponent = cloneDeep(textComponent);
  updatedComponent.lexicalState = lexicalState;
  cache.set(cacheKey, updatedComponent);

  return updatedComponent;
}
